import { instanceGuard } from '@superbet-group/web.lib.utilities';

import RestService from '@core/services/zendesk/_private/RestService';

import Singleton from '../common/Singleton';
import SingletonError from '../common/errors/SingletonError';
import { ShellLocalConfig } from '@src/config/shell/localConfigTypes';

class ZendeskService {
    private static instance?: ZendeskService;

    public static getInstance(): ZendeskService {
        return instanceGuard(ZendeskService.instance);
    }

    public static createInstance(config: ShellLocalConfig) {
        if (!ZendeskService.instance) {
            ZendeskService.instance = new ZendeskService(config);
        }
        return ZendeskService.instance;
    }

    private constructor(private config: ShellLocalConfig, private restService = new RestService()) {
        if (ZendeskService.instance) {
            throw new SingletonError(this.constructor.name);
        }
    }

    public setRestService(restService: RestService) {
        this.restService = restService;
    }

    // ============================
    // Rest methods
    // ============================

    public async getAuthenticationToken({
        email,
        name,
        id,
    }: {
        email: string;
        name: string;
        id: string;
    }): Promise<string> {
        const response = await this.restService.getZendeskToken({ email, name, id });
        return response.data?.jwtToken;
    }

    public static clearInstance() {
        if (process.env.NODE_ENV !== 'test') {
            throw new Error('For use in tests only');
        }
        delete ZendeskService.instance;
    }
}

export default ZendeskService as Singleton<ZendeskService>;
